import axios from 'axios';
import Cookies from 'js-cookie';
import { CONFIG } from '@/config/Config';
import { getAccountId, getUniId } from '@/core/utils/extractCookieId';

export interface Metrics {
  'universe': {
    'universe_id': number,
    'universe_name': string,
    'status': string,
    'colorpicker': string,
    'start_date': string,
    'created_at': string,
  },
  'account': {
    'account_id': number,
    'account_name': string
  },
  'limits': {
    'total_posts_limit': number,
    'month_posts_limit': number,
    'month_posts': number,
    'posts_collected': number,
    'total_group_posts': number,
    'total_any_group_posts': number,
    'total_listening_posts': number,
    'total_proprietary_posts': number,
    'total_competitors_proprietary_posts': number,
    'total_month_listening_posts': number,
    'total_month_proprietary_posts': number,
    'total_month_posts': number,
    'total_month_competitors_proprietary_posts': number,
    'size': number
  },
  'twitter_enterprise': {
    'limit': number,
    'collected': number
  }
}

class MetricsService {
  private createAuthenticatedAxios() {
    const axiosInstance = axios.create();
    
    axiosInstance.interceptors.request.use((config) => {
      const token = Cookies.get(CONFIG.AUTH.SSID);

      if (token) {
        config.headers[CONFIG.AUTH.SSID] = token;
      }

      return config;
    });

    return axiosInstance;
  }

  async getUniverseLimits(): Promise<Metrics> {
    const gateway = CONFIG.getSecureStagingGatewayUrl();
    const version = CONFIG.getVersion();
    const uni_id = getUniId();
    const acc_id = getAccountId();

    const url = `${gateway}panels-service/${version}/v2/panels/getuniverselimit/${acc_id}/${uni_id}`;
    
    const axiosInstance = this.createAuthenticatedAxios();
    const response = await axiosInstance.get(url);
    
    return response.data;
  }
}

const metricsService = new MetricsService();
export default metricsService;